import { Pipe, PipeTransform } from "@angular/core";

// Methods that accept at least one number argument as the first parameter (exclude zero-arg like random)
type MathMethodsWithParameters = {
    [Key in keyof Math]: Math[Key] extends (first: number, ...rest: number[]) => number ? Key : never;
}[keyof Math];

// Narrow to exactly one-argument methods (no additional parameters beyond the first)
type MathMethodsWithExactlyOneParameter = {
    [Key in MathMethodsWithParameters]: Math[Key] extends (a: number, ...rest: infer R) => number
        ? R["length"] extends 0
            ? Key
            : never
        : never;
}[MathMethodsWithParameters];

// Methods that take the first parameter and at least one more (fixed 2+ or variadic)
type MathMethodsWithAtLeastTwoParameters = Exclude<MathMethodsWithParameters, MathMethodsWithExactlyOneParameter>;

@Pipe({
    name: "math",
})
export class MathPipe implements PipeTransform {
    public transform(value: number | undefined | null, operation: MathMethodsWithExactlyOneParameter): number;
    public transform(
        value: number | undefined | null,
        operation: MathMethodsWithAtLeastTwoParameters,
        ...args: [number, ...number[]]
    ): number;
    public transform(value: number | undefined | null, operation: MathMethodsWithParameters, ...args: number[]): number {
        const areValidArgs = args.every((arg) => !isNaN(arg));

        if (value === undefined || value === null || isNaN(value) || !areValidArgs) {
            return Number.NaN;
        }

        try {
            return Math[operation].call(Math, value, ...args);
        } catch (error) {
            return Number.NaN;
        }
    }
}
